/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
  TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
} from '../types/TelegramNotificationsPublicControllerUnsubscribeByLink.ts';

function getTelegramNotificationsPublicUnsubscribeByLinkUrl() {
  const res = { method: 'GET', url: `/api/telegram/notifications/unsubscribe` as const };
  return res;
}

/**
 * {@link /api/telegram/notifications/unsubscribe}
 */
export async function telegramNotificationsPublicUnsubscribeByLink(
  params: TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getTelegramNotificationsPublicUnsubscribeByLinkUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
